'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../../i-bem/i-bem.react');

var _bButton2MThemeNormal = (require('./../../button2/button2.react.js').default || require('./../../button2/button2.react.js')).applyDecls();

var _bButton2MThemeNormal2 = _interopRequireDefault(_bButton2MThemeNormal);

var _eSticker = (require('./../__sticker/tumbler__sticker.react.js').default || require('./../__sticker/tumbler__sticker.react.js')).applyDecls();

var _eSticker2 = _interopRequireDefault(_eSticker);

void 0;

var _bTumblerTI18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./../tumbler.i18n/ru'))('tumbler');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./../tumbler.i18n/en'))('tumbler');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./../tumbler.i18n/be'))('tumbler');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./../tumbler.i18n/id'))('tumbler');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./../tumbler.i18n/kk'))('tumbler');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./../tumbler.i18n/tr'))('tumbler');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./../tumbler.i18n/tt'))('tumbler');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./../tumbler.i18n/uk'))('tumbler');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
    }

    return function () {};
}();

var _bTumblerTI18n2 = _interopRequireDefault(_bTumblerTI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'tumbler',
    elem: 'box',
    tag: 'span',
    willInit: function willInit() {
        this.onClick = this.onClick.bind(this);
        this.buttonReference = this.buttonReference.bind(this);
    },
    attrs: function attrs() {
        return _extends({}, this.__base.apply(this, arguments), {
            onClick: this.onClick
        });
    },
    content: function content(_ref) {
        var id = _ref.id,
            view = _ref.view,
            checked = _ref.checked,
            disabled = _ref.disabled,
            tabIndex = _ref.tabIndex;

        var labelledBy = this.context.getLabel(id);

        return [_react2.default.createElement(
            _eSticker2.default,
            _extends({ key: '0' }, { position: 'left' }),
            (0, _bTumblerTI18n2.default)('on')
        ), _react2.default.createElement(
            _eSticker2.default,
            _extends({ key: '1' }, { position: 'right' }),
            (0, _bTumblerTI18n2.default)('off')
        ), _react2.default.createElement(_bButton2MThemeNormal2.default, _extends({ key: 'button' }, {
            theme: 'normal',
            size: 'm',
            tabIndex: tabIndex,
            view: view === 'classic' ? 'classic' : false,
            disabled: disabled,
            mix: { block: 'tumbler', elem: 'button' },
            innerRef: this.buttonReference,
            attrs: {
                'aria-labelledby': labelledBy,
                'aria-pressed': String(checked)
            }
        }))];
    },
    onClick: function onClick(event) {
        this.button.focus();
        this.props.onChange && this.props.onChange(event);
    },
    buttonReference: function buttonReference(button) {
        this.button = button;
        this.props.buttonRef && this.props.buttonRef(button);
    }
}, {
    contextTypes: {
        getLabel: _propTypes2.default.func
    }
});